import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "modal", "certification", "confirm"];

  onToggleChange() {
    // Only intercept when enabling the toggle. Disabling doesn't require confirmation.
    if (!this.toggleTarget.checked) return;

    this.toggleTarget.checked = false;
    this.openModal();
  }

  onCertificationChange() {
    this.confirmTarget.disabled = !this.certificationTarget.checked;
  }

  confirm(event) {
    event.preventDefault();
    if (!this.certificationTarget.checked) return;

    this.toggleTarget.checked = true;
    this.closeModal();
  }

  cancel(event) {
    event?.preventDefault();
    this.toggleTarget.checked = false;
    this.closeModal();
  }

  openModal() {
    this.resetModal();
    this.modalTarget.classList.remove("hidden");
  }

  closeModal() {
    this.modalTarget.classList.add("hidden");
    this.resetModal();
  }

  resetModal() {
    this.certificationTarget.checked = false;
    this.confirmTarget.disabled = true;
  }
}
